import { render, staticRenderFns } from "./FingerPrintSideBox.vue?vue&type=template&id=fa09763e&scoped=true"
import script from "./FingerPrintSideBox.vue?vue&type=script&lang=js"
export * from "./FingerPrintSideBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa09763e",
  null
  
)

export default component.exports